<template>
  <div class="content">

    <s-location apply title="미사용 증표 환불 신청"/>
    <!-- //검색창 -->
    <div class="flow_wrap arr">
      <li  class="on">
        <b>01</b> 미사용 증표<br class="mobile" />환불 신청
      </li>
      <li class="arr"></li>
      <li>
        <b>02</b>환불 신청 <br class="mobile" />접수
      </li>
      <li class="arr"></li>
      <li>
        <b>03</b>등록된 계좌로 환급<br class="mobile"/><small>(접수 후 2주이내)</small>
      </li>
    </div>
    <!--  주의사항  -->
    <div class="comment_gray expcomment mt_15">
      <p class="tit">미사용 증표 환불 신청 안내</p>
      <li>경유증표를 구입했으나, 다른 지방변호사회로의 소속변경, 휴업 등의 사유로 더 이상 경유증표를 사용하지 못하거나 일정 기간 사용할 일이 없어 경유증표 구입 대금을 환불받고자 할 경우에 해당합니다.</li>
    </div>

    <h4 class="sub_title02">미사용 증표 현황</h4>

      <div class="btn_group mt0">
        <div class="right">
          <button @click="initData" class="btn icon reload">초기화</button>
          <button @click="doSearch" class="btn icon search_black">검색</button>
          <button @click.prevent="$refs.excel.down()" class="btn icon excel">엑셀 다운</button>
        </div>
      </div>
    <table class="tbl01 sch_tbl">
      <tr>
        <th>구입일</th>
        <td>
          <i-input-date input-class="w_inputno" title="시작일" v-model="search.iv_selldtfr" :placeholder="search.iv_selldtfr"/>
        ~ <i-input-date input-class="w_inputno" title="종료일" v-model="search.iv_selldtto" :placeholder="search.iv_selldtto"/>
        <br class="mobile"/>
          <s-date-range :fr.sync="search.iv_selldtfr" :to.sync="search.iv_selldtto" />
        </td>
      </tr>
      <tr>
        <th>증표 종류</th>
        <td>
          <!-- 공익(B10400), 면제(B10500) 제외 -->
          <c증표종류_검색폼
            :search.sync="search"
            :except_code="except_code"
            @select="doSearch"
          />
        </td>
      </tr>
      <tr>
        <th>증표 번호</th>
        <td>
            <input type="text" v-model="search.iv_rcptnofr_1" class="w_inputno" @keyup.enter="doSearch" v-mask="'#####'" v-on:keyup="$event.target.value.length >= 5 && $event.target.nextElementSibling.focus()"/> -
            <input type="text" v-model="search.iv_rcptnoto_1" class="w_inputno" @keyup.enter="doSearch" v-mask="'######'"/>
        </td>
      </tr>
      <tr>
        <th>검색어</th>
        <td>
          <select v-model="search.iv_ktype">
            <option value="ALL"      >전체</option>
            <option value="MEMBNM"   >증표명의</option>
            <option value="CLIENT"   >위임인</option>
            <option value="OTHERSIDE">상대방</option>
            <option value="REMK"     >비고</option>
          </select>
          <input type="text" class="sch_input" title="검색어" v-model="search.iv_kword" placeholder="검색어" @keyup.enter="doSearch"/>
        </td>
      </tr>
    </table>

    <s-excel
      ref="excel"
      excel-api="/proc_excel/N_VIAINFO_SEL_LIST_EMP"
      excel-filename = "미사용증표"
      :isDebug="false"
      :excel-top ="`

          조회기간 : ${ search.iv_selldtfr } ~ ${ search.iv_selldtto }

      `"
      excel-headers = "
          text           | value            | format
          구입일자       | selldt           | YYYY.MM.DD
          증표명의       | ownernm          |
          증표종류       | org_caseclsfnm   |
          증표번호       | rcptno           | insertHyphen(5)
          비고           | remk             |
      "
      :excel-param = "()=>({
        ...search,
        iv_pgsize      : '-1',
        iv_page        : '1',
    })"/>


    <h4 class="sub_title02">검색 결과</h4>

    <s-loading v-if="list.loading"/>
    <div class="scroll_wrap w600"> <!--모바일 스크롤 -->
      <p class="scroll_txt"> &lt;-&gt; 좌우 스크롤을 이용하세요</p>

      <!-- 테이블 -->
      <table class="tbl01 ">
        <thead>
          <tr>
            <th class="no" >순번</th>
            <th class="date">구입일자</th>
            <th class="vianame">증표명의</th>
            <th class="viakind">증표종류</th>
            <th>증표금액</th>
            <th class="viano">증표번호</th>
            <th>비고</th>
            <th class="btn01">추가</th>
          </tr>
        </thead>
        <tr v-for="(item,i) in list.items" :key=i :class="{ 'bg_gray01' : !showPlusBtn(item) }">
          <td>{{ list.totalCount - ((list.pageNo -1) * list.listSize) - i }}</td>
          <td>{{ item.selldt | moment('YYYY.MM.DD') }}</td>
          <td v-html="T.nl_to_br(item.ownernm)"></td>
          <td>{{ item.org_caseclsfnm  }}</td>
          <td class="al_amt">{{ item.viafee | comma  }} 원</td>
          <td>{{ item.rcptno | insertHyphen(5) }}</td>
          <td class="al_l">{{ item.remk  }}</td>
          <!-- <td><a href="buy_receipt" class="btn xs gray01 outline">추가</a></td> -->
          <td>
            <img v-if="showPlusBtn(item)"
                 src="/images/common/icon_plus_blue.png"
                 class="icon_squ"
                 @click="addRow(item)">
          </td>
        </tr>
      </table>
     </div> <!--// scroll_wrap -->

    <!-- paging -->
    <div class="paging">
      <p class="num">
        <s-page :pageNo.sync="list.pageNo" :totalCount="list.totalCount" :listSize="list.listSize" @changePage="doSearch"/>
      </p>
    </div>
    <!-- /paging -->

    <div class="scroll_wrap w600"> <!--모바일 스크롤 -->
      <h4 class="sub_title02">환불할 증표 현황</h4>

      <p class="scroll_txt mt10"> &lt;-&gt; 좌우 스크롤을 이용하세요</p>
      <table class="tbl01 mt10">
        <thead>
          <tr>
            <th class="no" >순번</th>
            <th class="date">구입일자</th>
            <th class="vianame">증표명의</th>
            <th class="viakind">증표종류</th>
            <th>증표금액</th>
            <th class="viano">증표번호</th>
            <th>비고</th>
            <th class="btn01">제거</th>
            <!-- <th class="btn01">추가</th> -->
          </tr>
        </thead>

        <tr v-for="(item,i) in saveList" :key=i>
          <td>{{ i + 1 }}</td>
          <td>{{ item.selldt | moment('YYYY.MM.DD') }}</td>
          <td v-html="T.nl_to_br(item.ownernm)"></td>
          <td>{{ item.org_caseclsfnm  }}</td>
          <td class="al_amt">{{ item.viafee | comma  }} 원</td>
          <td>{{ item.rcptno | insertHyphen(5) }}</td>
          <td class="al_l">{{ item.remk  }}</td>
          <!-- <td><a href="buy_receipt" class="btn xs gray01 outline">추가</a></td> -->
        <td>
          <img src="/images/common/icon_minus_org.png"
              class="icon_squ"
              @click="delRow(item)">
        </td>
      </tr>
      </table>
     </div> <!--// scroll_wrap -->

    <!-- 변경내용 -->
    <h4 class="sub_title02">변경 내용</h4>

    <!-- 테이블 : 환불 내용 -->
    <table class="tbl01 sum ">
      <tr>
        <th>환불 사유</th>
        <td class="al_l input_etc" >
          <select v-model="sitem.reasonclsf">
             <option value="" selected="selected">선택</option>
             <option v-for="item in code.RREFUND"
                    :value="item.value"
                    :key="item.value">{{item.text}}</option>
           </select>
           <input type="text"
                  v-model="sitem.reasonremk"
                  v-if="sitem.reasonclsf == 'ETC'"
                  placeholder="기타사유"
                  />
        </td>
      </tr>
      <tr>
        <th class="al_t">환불 금액</th>
        <td class="infoamt">
          {{ rf_amt | comma}} 원
          <span class="red01 right"><b>환불금액은 증표명의자의 계좌로만 입금 가능합니다.</b></span>
        </td>
      </tr>
      <tr>
        <th class="al_t">은행명</th>
        <td class="infoamt bankinfo_wrap">
          <li clas="bankinfo_th">
            <select v-model="sitem.rfbankcode">
            <option value="" selected="selected">선택</option>
            <option v-for="item in code.BANKCODE"
                    :value="item.value"
                    :key="item.value">{{item.text}}</option>
            </select>
          </li>
          <div class="bankinfo">
            <li>
              <span>환불계좌번호 </span>
              <input type="text" v-model="sitem.rfaccno"  placeholder="000-00-00000">
            </li>
            <li><span>예금주 </span><input type="text" v-model="sitem.rfaccname"></li>
          </div>
        </td>
      </tr>
      <tr>
        <th class="al_t">통장사본<br class="mobile"/>(첨부파일)</th>
        <td class="infoamt">

          <i-fileupload name="file1" ref="file1" v-model="file1"
            :action="$api + '/attach'"
            autoUpload required
            kind="bankauth"
            :exts="'jpeg,jpe,jpg,gif,png,pdf'.split(/,/)"
            @done="file=>sitem.attachid = file.uuid"
            >

            <template v-slot:dropArea="{isDropActive, files}">
              <div v-if="$mq != 'mobile' && !file1.name" class="file_drag" :style="{ 'background-color': isDropActive ? 'green' : 'gray' }">
                Drag And Drop
              </div>
            </template>

            <template v-slot:uploadFile="{file, remove}">
              {{ file.name }} ( 용량 : {{ file.size | comma }} byte )
              <i-btn class="btn" @click.prevent="remove(file);sitem.attachid=null" :key="file.id">취소</i-btn>
            </template>

            <button v-if="!file1 || !file1.name"
              class="btn gray01 outline btn_filesel">
              파일선택
            </button>

            &nbsp;
          </i-fileupload>

          <div class="mt15">
             ※ 통장 실물이 없는 경우 계좌개설확인서를 첨부해 주세요. ( jpg,gif,png,pdf )
          </div>
        </td>
      </tr>
    </table>
    <!-- //테이블 : 환불 내용 -->

    <div class="btn_group">
      <div class="right">
        <button @click="doInit"   class="btn m gray01 outline ">취소</button>
        <button @click="saveItem" class="btn m gray01 ">신청</button> <!-- href="buy_ok" -->
      </div>
    </div>

	</div> <!-- content : width=950px; -->

</template>

<script>
let ui
export default {
   components: {
     'c증표종류_검색폼'   : require('@/components/c증표종류_검색폼.vue').default
   },
   data () {
    return {
      search : {},
      search_init : {
        iv_menu         : 'refund'
      , iv_selldtfr     : ""//this.$moment().format("YYYY-MM-DD")
      , iv_selldtto     : ""//this.$moment().format("YYYY-MM-DD")
      , iv_statclsf     : "BC0100"     // 미사용건만 출력
      , iv_viadtfr      : ""
      , iv_viadtto      : ""
      , iv_viaplac      : ""
      , iv_caseclsf     : ""
      , iv_rcptnofr_1   : ""
      , iv_rcptnoto_1   : ""
      , iv_rcptnofr     : ""
      , iv_rcptnoto     : ""
      , iv_cntchargdtfr : ""
      , iv_cntchargdtto : ""
      , iv_client       : ""
      , iv_isttoutplac  : ""
      , iv_otherside    : ""
      , iv_linkyn       : ""
      , iv_lostyn       : ""
      , iv_onlineyn     : "Y" // 19.12.31 215번 요청사항 : 종이증표는 나오지 않게
      , iv_lawyernm     : ""
      , iv_membclsf     : ""
      , iv_membno       : ""
      , iv_membnm       : ""
      , iv_viamembclsf  : ""
      , iv_viamembno    : ""
      , iv_officeclsf   : ""
      , iv_officeno     : ""
      , iv_order_by1    : ""
      , iv_order_by2    : ""
      , iv_order_by3    : ""
      , iv_order_by4    : ""
      , iv_freeclsf     : ""
      , iv_case_b10300  : ""
      , iv_ktype        : "ALL"
      , iv_kword        : ""
      , iv_cancelclsf   : ""
      , iv_searchdtgbn  : ""
      , iv_searchfr     : ""
      , iv_searchto     : ""
      },
      sitem : {},
      sitem_init : {
        reasonclsf  : ''
      , reasonremk  : ''
      , rfway       : 'BANK' // 환불수단 : 계좌이체
      , rf_amt      : 0
      , rfbankcode  : ''
      , rfaccno     : ''
      , rfaccname   : ''
      , attachid    : '' // 첨부파일 ID
      , attachid2   : '' // 첨부파일 ID2
      },
      code: {},
      chkAll : false,
      list: {
        loading: false,
        items: [],
        totalCount: 0,
        listSize : 10,
        pageNo : 1,
      },
      saveList : [],
      except_code : ['B10400', 'B10500'], // 증표종류 검색조건 : 공익(B10500), 면제(B10400) 제외
      dayStr: ['일', '월', '화', '수', '목', '금', '토'],
      date: '2018-06-01',
      file1: {},

      defaultPopperProps : {
        arrowPosition: 'start',
        arrowOffsetScaling: 1,
        popperOptions: {
          placement: 'bottom-start',
          positionFixed: true,
          // more options in https://popper.js.org
        },
      },
    }
  },
  watch : {
    '$route': 'initData',
  },
  created() {
    ui = this.$ui;
    this.search = { ...this.search_init }
    this.sitem  = { ...this.sitem_init }
  },
  mounted() {
     // 공통코드 로드
    ui.codeLoad("RREFUND, BANKCODE", code => {
      this.code = code
    });

  },
  computed : {
    rf_amt() {
      return this.saveList.reduce((prev, item) => prev + T.toInt(item.viafee), 0)
    }
  },
  methods : {
    initData(){ // 현재 메뉴 다시 클릭 시
      this.search = T.deepCopy(this.search_init)
      this.sitem  = T.deepCopy(this.sitem_init)
      this.saveList = []
      this.file1 = {}
      this.$refs.file1.clear()
      this.doSearch()
    },
    doInit(){
      this.sitem  = T.deepCopy(this.sitem_init)
      this.saveList = []
      this.file1 = {}
      this.$refs.file1.clear()
    },
    addRow(item) {
      if (this.saveList.filter(e => e.viaregdt == item.viaregdt && e.viaseq == item.viaseq).length > 0) {
        return ui.alert("이미 선택된 증표입니다. 선택 리스트를 확인해 주세요.")
      }

      this.saveList.push(item)
    },
    delRow(item) {
      this.saveList = this.saveList.filter(e => !(e.viaregdt == item.viaregdt && e.viaseq == item.viaseq))
    },
    showPlusBtn(item) {
      return !this.saveList.some(e => e.viaregdt == item.viaregdt && e.viaseq == item.viaseq)
    },
    doSearch() {
      this.search.iv_rcptnofr = this.search.iv_rcptnofr_1 + "" + this.search.iv_rcptnoto_1
      this.search.iv_rcptnoto = this.search.iv_rcptnofr

      ui.httpGetList(this.list
        , '/proc/N_VIAINFO_SEL_LIST_EMP'
        , {
          ...this.search
          , iv_pgsize      : this.list.listSize
          , iv_page        : this.list.pageNo
        },
        ret => {
          this.list.totalCount = _.get(ret, "data.rs1[0].tot_rows", 0)
          this.list.items      = _.get(ret, "data.rs2", [])
        })
    },
    saveItem() {
      if (this.saveList.length == 0) {
        return ui.alert("환불신청할 증표를 추가해 주세요.")
      }

      ui.confirm('신청하시겠습니까 ?', "신청확인")
        .then(r => r && this.itemUpdate())
    },
    itemUpdate() {
      this.saveList.some((item, i) => {
        this.sitem.viaregdt = ((i == 0) ? '' : this.sitem.viaregdt + '#') + item.viaregdt
        this.sitem.viaseq   = ((i == 0) ? '' : this.sitem.viaseq   + '#') + item.viaseq
      })

      this.sitem.rf_amt = this.rf_amt;

      ui.httpPost("/proc_iv/N_VIASTAT_UPD",
      {
        ...this.sitem
        , viastatclsf  : 'REFUND'
        , approveclsf  : 'REQ'
        , approvemsg   : ''
        , viastatdt    : ''
        , viastatseq   : ''
        , viastatdtlid : ''
        , caseclsf     : ''
        , to_membclsf  : ''
        , to_membno    : ''
        , to_caseclsf  : ''
        , to_casetype  : ''
        , to_viafee    : 0
        , to_amt       : 0
        , remk         : ''
      },
      ret => {
        const {msg, status, sellregdt ,sellseq} = ret.data.rs1[0];
        ui.notify(msg);

        if (status == '0') { // 작업이 정상 완료일때 신청내역 페이지로 이동
           this.$router.push({ path: 'stat_list' })
        }

      })
    }
  }
}
</script>
<style scoped>
  .tbl01.sum th { width:160px; text-align: center}

  .tbl01.sum th { width:160px; text-align: center}
  .tbl01 td.al_amt { padding-right:5px;box-sizing: border-box; text-align: right;}


  @media screen and (max-width:640px){

/*     .flow_wrap li { font-size: 12px; height:102px; line-height: 1.6;    text-align: center; padding:5px; letter-spacing: -1px; width:30%; padding:50px 0 0 0}
    .flow_wrap li b { display: inline-block; width:100%; top:0; text-align: center; vertical-align: middle; line-height: 40px; height:40px; }
    .flow_wrap li.arr { width:15px; }
 */
    .tbl01.sum tr th { width:90px; vertical-align: top;}
    .tbl01.sum tr td button { margin-bottom:0px; display: inline; max-width: 100px; }

    .file_input input[type="file"] { display: none;}
    .file_input input { width:calc(100% - 100px); margin-bottom:0;}
    /* .bankinfo {margin-top:160px; margin-left:-50px; position: absolute ;} */
    .bankinfo_th { height:200px; display: inline;}
    .infoamt.bankinfo_wrap li { vertical-align: top; display: inline-block; text-align: left; float:none !important; margin:0  !important; width:100%; height:105px;}
    .infoamt.bankinfo_wrap .bankinfo { position: absolute ; vertical-align: top; margin:-72px  0 0 -94px; }
    .infoamt.bankinfo_wrap .bankinfo li { vertical-align: top; display: inline-block; text-align: left; float:none !important; margin:0  !important; width:100%; height:42px;}
    .infoamt.bankinfo_wrap .bankinfo li span { width:94px; display: inline-block; text-align: left;}


  }
</style>
